var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_151",
    "data-name": "Group 151",
    viewBox: "0 0 15.909 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    d: "M11.4 18H4.9a2.476 2.476 0 0 1-2.4-2.2l-.7-9.4a.908.908 0 0 1 .3-.7.908.908 0 0 1 .7-.3h10.7a.908.908 0 0 1 .7.3 1.08 1.08 0 0 1 .3.7l-.7 9.4a2.4 2.4 0 0 1-2.4 2.2zM3.8 7.3l.6 8.4a.458.458 0 0 0 .5.4h6.5a.458.458 0 0 0 .5-.4l.6-8.4H3.8z",
    className: "cls-1",
    "data-name": "Path 166"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    d: "M14.3 7.2H1.7A1.685 1.685 0 0 1 0 5.5V3.2a1.752 1.752 0 0 1 1.7-1.7h2.1A1.728 1.728 0 0 1 5.5 0h5.3a1.728 1.728 0 0 1 1.7 1.5h1.7a1.752 1.752 0 0 1 1.7 1.7v2.3a1.55 1.55 0 0 1-1.6 1.7zM1.9 5.3h12.2V3.4h-1.7a1.728 1.728 0 0 1-1.7-1.5h-5A1.649 1.649 0 0 1 4 3.4H1.9zm12.4-1.9zm-1.8-1.7z",
    className: "cls-1",
    "data-name": "Path 167"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    d: "M6.4 14.6a1 1 0 0 1-1-1V9.1a1 1 0 0 1 1-1 .945.945 0 0 1 1 1v4.6a1.063 1.063 0 0 1-1 .9z",
    className: "cls-1",
    "data-name": "Path 168"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    d: "M10.2 14.6a1 1 0 0 1-1-1V9.1a1 1 0 0 1 1-1 .945.945 0 0 1 1 1v4.6a.987.987 0 0 1-1 .9z",
    className: "cls-1",
    "data-name": "Path 169"
  })))));
}
export default __webpack_public_path__ + "static/media/ic_trash.6e56215b.svg";
export { SvgIcTrash as ReactComponent };